import React, { useState, useEffect, useCallback, useContext, useRef } from 'react'
import * as dumbleData from 'DumbleData';
import './ResultsPage.scss'
import Modal from './Modal';
import constructorio, { constructorPod, recommendationsConstructor } from 'utils/Constructorio.js';
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { ConfigContext } from 'providers/ConfigContext';
import Cookies from 'js-cookie';

import Nav from 'components/structure/Nav/Nav.js';
import BookCard from 'components/content/BookCard/BookCard.js';
import BookALikeHeader from './BookALikeHeader/BookALikeHeader.js';
import LevelHeaderSearch from 'components/content/ResultsPage/LevelHeaderSearch/LevelHeaderSearch.js';
import DiscoveryHeaderFilters from 'components/content/ResultsPage/DiscoveryHeaderFilters/DiscoveryHeaderFilters.js';
import ViewAllBar from 'components/content/ResultsPage/ViewAllBar/ViewAllBar.js';
import ViewAllCard from 'components/content/ResultsPage/ViewAllCard/ViewAllCard.js';
import ZeroResultsPage from './ZeroResultsPage/ZeroResultsPage.js';
import SaveToWishlistAlert from './SaveToWishlistAlert/SaveToWishlistAlert.js';

const readingLevels = new Set(['acceleratedReaderLevel', 'draLevel', 'guidedReadingLevel', 'lexileLevel']);


export default function ResultsPage(props) {
	const configContext = useContext(ConfigContext);
	const tsoOrigin = configContext.tso.origin;
	const [searchResults, setSearchResults] = useState([]);
	const [searchQuery, setSearchQuery] = useState('');
	const [browseFacets, setBrowseFacets] = useState([]);
	const [numResults, setNumResults] = useState(0);
	const [isFilteredResults, setIsFilteredResults] = useState(false);
	const [headerOffset, setHeaderOffset] = useState(98);
	const [navOffset, setNavOffset] = useState(70);
	const [hideOnScroll, setHideOnScroll] = useState(true)
	const [addToCartItem, setaddToCartItem] = useState(null);
	const [saveToWishlistItem, setSaveToWishlistItem] = useState({})
	const [wishlistAlert, setWishlistAlert] = useState(false)
	const [isLoadingResults, setIsLoadingResults] = useState(false);
	const [bookALikeItem, setBookALikeItem] = useState(null);
	const [openMultipleWishlistModal, setOpenMultipleWishlistModal] = useState(false);

	const Wishlist_Queue = "Wishlist_Queue";

	// Ref to store the timout ID of the saveToWishlist alert, in case the user closes it preemptively
	const alertTimeout = useRef(0)

	const {isSignedIn, setIsSignedIn, myScholasticModal, setMyScholasticModal} = props

	const handleSearchQuery = useCallback((query) => {
		setIsLoadingResults(true)
		constructorio.search.getSearchResults(
			query,
			{
				filters: {
					'product-type': 'books/individual-titles'
				}
			}
		).then((data) => {
			dumbleData.setResults(data, query);
			let results = filterResults(data.response.results).slice(0,10);
			setSearchResults(results);
			setSearchQuery(query);
			setNumResults(calculateNumResults(results.length, data.response.total_num_results));
		}).catch((error) => {
			console.log(error);
		}).finally(() => {
			setIsLoadingResults(false)
		});
	}, [])

	const handleBrowseQuery = useCallback((facets) => {
		setIsLoadingResults(true)
		constructorio.browse.getBrowseResults(
			'product-type',
			'books/individual-titles',
			{
				filters: {
					...(facets[0] !== '') && {[facets[0]]: facets[1]},
					'grade': facets[2],
					'super-genre': facets[3],
					'subject': facets[4],
					'genre': facets[5]
				}
			}
		).then((data) => {
			dumbleData.setResults(data, facets);
			dumbleData.trackDiscoverResults();
			let results = filterResults(data.response.results).slice(0,10);
			setSearchResults(results);
			setBrowseFacets(facets);
			setNumResults(calculateNumResults(results.length, data.response.total_num_results))
		}).catch((error) => {
			console.log(error);
		}).finally(() => {
			setIsLoadingResults(false)
		});
	}, [])

	useEffect(() => {
		dumbleData.setPageType('Results');
		dumbleData.setTitle('BookWizard:Results');
		dumbleData.trackPageLoad();

		if(props.location.search) {
			let query = new URLSearchParams(props.location.search).get("q")
			// If the user refreshes the page on a search, repopulates search data
			if (!window.dumbleData.omniture.search.type) {
				dumbleData.setSearchTypeInputKeyword('user-entered', query)
			}
			handleSearchQuery(query);
		} else if(props.location.state && props.location.state.browseFacets) {
			setIsFilteredResults(true);
			dumbleData.setSearchType("discovery-flow")
			handleBrowseQuery(props.location.state.browseFacets);
		}
	}, [handleSearchQuery, handleBrowseQuery, props.location])

	// Effect for fetching Book-a-Like recommendations when a Book-a-Like button is clicked
	useEffect(() => {
		/** Accepts a list of Constructor recommendations and filters them based on 2 parameters:
		 *  1. Filters out any books that are not individual titles (collections, etc.)
		 *  2. Removes any books that do not have any reading level information (lexile, guided, etc.)
		 */
		const filterRecommendations = (recs) => {
			return recs.filter((book) => {
				let productTypeFacet = book.data.facets.find(({name}) => name === 'product-type')
				let productType = productTypeFacet.values[1]
				let hasReadingLevels = book.data.facets.some(({name}) => readingLevels.has(name))
				return productType === 'books/individual-titles' && hasReadingLevels
			})
		}
		// calls Constructor using the recommendations module and populates the searchResults state variable
		const fetchRecommendations = async () => {
			const data = await recommendationsConstructor.recommendations.getRecommendations(constructorPod, {
				itemIds: bookALikeItem.data.id,
				numResults: 20
			})
			let results = filterRecommendations(data.response.results).slice(0,10)
			setSearchResults(results)
			dumbleData.trackPageLoad();
			dumbleData.trackBookALikeSearch(results.length, bookALikeItem.value)
		}
		if (bookALikeItem) {
			fetchRecommendations()
		}
	}, [bookALikeItem])

	useEffect(() => {
		let isMobile = window.matchMedia('(max-width: 719px)').matches;
		if(isMobile && navOffset === 70){
			setNavOffset(90);
		} else if(!isMobile && navOffset === 90){
			setNavOffset(70);
		}
	}, [navOffset, headerOffset])

	const updateLocalStorageWishlist = (isbn13) => {
		let wishlistItems = JSON.parse(
			localStorage.getItem(Wishlist_Queue)
		);
		// add item to local storage wishlist if it's not in it already
		if (wishlistItems && wishlistItems.length > 0) {
			if (!wishlistItems.includes(isbn13)) {
				wishlistItems.push(isbn13);
			}
		} else {
			// create local storage wishlist if it doesn't exist
			wishlistItems = [];
			wishlistItems.push(isbn13);
		}
		localStorage.setItem(
			Wishlist_Queue,
			JSON.stringify(wishlistItems)
		);
	};


	/** When the Book-a-Like button is clicked, get the data of the book from the
	 *  search results, and set the bookALikeItem state variable
	 */
	const handleBookALikeClick = (isbn) => {
		let bookALikeResult = searchResults.find(book => book.data.id === isbn)
		window.scrollTo(0,0)
		setTimeout(function() {
			setBookALikeItem(bookALikeResult)
		}, 100)
	}

	/** Filters out any results that do not have reading level information,
	 *  which is located in the facets property
	 */
	const filterResults = (data) => {
		return data.filter(book => {
			return book.data.facets?.some(({name}) => readingLevels.has(name))
		})
	}

	/** If the number of filtered results is 10, but the total number
	 *  of results returned from constructor is greater than 10, return 
	 *  totalNumResults. Otherwise, return resultsLength
	 */
	const calculateNumResults = (resultsLength, totalNumResults) => {
		if (resultsLength === 10 && totalNumResults > 10) {
			return totalNumResults
		}
		return resultsLength
	}

	/** Wrapping this in a callback so it can be passed down and
	 *  not cause any effects from running unnecessarily
	 */
	const handleHeaderUpdate = useCallback((headerHeight) => {
		setHeaderOffset(headerHeight);
	}, [])

	/** Function that will remove any decimal codes, such as
	 *  &#233, which is é
	 */
	const decodeText = (text) => {
		let textArea = document.createElement("textarea");
		textArea.innerHTML = text;
		return textArea.value;
	}

	const inWishlistHelper = (isbn) => {
		let wishlistItemsTemp = JSON.parse(
			localStorage.getItem(Wishlist_Queue)
		);
		if (wishlistItemsTemp && wishlistItemsTemp.includes(isbn)) {
			return true;
		}
		return false;
	};


	useEffect(() => {
		if(openMultipleWishlistModal){
			document.body.style.overflow = 'hidden';
		}else{
			document.body.style.overflow = 'unset';
		}
	}, [openMultipleWishlistModal])


	/** When the save to wishlist button is clicked and the user is signed in,
	 *  add the book to their wishlist. If the user is not signed in, display
	 *  the sign-in modal. After the user signs in, add the book to their wishlist.
	 */
	 const handleWishlistClick = (productObject) => {
		dumbleData.setProductInfo(productObject,'wishlist');
		dumbleData.trackAddToWishlist();
		let sps_ud = Cookies.get('SPS_UD');
		if (!sps_ud) {
			props.setIsSignedIn(false);
			props.setMyScholasticModal({ isOpen: true, openedFrom: 'wishlist'})
		} else {
			setSaveToWishlistItem(productObject)
			setOpenMultipleWishlistModal(true);
		}
	}

	const callbackWishlist = useCallback((event) => {
		if (event && event.origin === tsoOrigin) {
			let responseMessage  = JSON.parse(event.data);
			//user clicked close icon
			if (responseMessage.status === 'CLOSE' || responseMessage.status === 'ERROR' ) {
				setOpenMultipleWishlistModal(false);
			} 
			if (responseMessage.status === 'AUTHENTICATE_USER' ) {
				setOpenMultipleWishlistModal(false);
				props.setMyScholasticModal({ isOpen: true, openedFrom: 'wishlist'})
			} 
			if (responseMessage.status === 'SUCCESS') {
				if(saveToWishlistItem.isbn){
					updateLocalStorageWishlist(saveToWishlistItem.isbn);
					setSaveToWishlistItem({})
				}
				setOpenMultipleWishlistModal(false);
			}
			if(responseMessage.status === 'REDIRECT'){
				setOpenMultipleWishlistModal(false);
				if(saveToWishlistItem.isbn){
					updateLocalStorageWishlist(saveToWishlistItem.isbn);
					setSaveToWishlistItem({})
				}
				window.open(responseMessage.data.wishlistUrl, '_blank');
			}
		}
	},[saveToWishlistItem.isbn, props, tsoOrigin]);

	const listen = (event) => {callbackWishlist(event)};

	useEffect(()=>{
		if(openMultipleWishlistModal){
			window.addEventListener("message", listen);
		}
		return () => {
			window.removeEventListener("message", listen);
		}
	},[openMultipleWishlistModal]);


	const renderBookCards = () => {
		// If there are results, display them in book cards
		if (numResults > 0) {
			return searchResults.map((book, index) =>
				<BookCard
					key={book.data.id}
					isbn={book.data.id}
					img={book.data.image_url}
					title={book.value}
					format={book.data.displayFormat}
					grade={book.data.displayGrade}
					listPrice={book.data.listPrice}
					onSale={book.data.on_sale}
					displayPrice={book.data.displayPrice}
					author={book.data.author ? decodeText(book.data.author) : ''}
					illustrator={book.data.illustrator ? decodeText(book.data.illustrator) : ''}
					url={tsoOrigin + book.data.url}
					facets={book.data.facets ? book.data.facets : ''}
					handleAddToCart={handleAddToCart}
					addToCartButtonLabel={JSON.parse(book.data.button).label.trim().toUpperCase()}
					inWishlist={inWishlistHelper(book.data.id)}
					productId={book.data.mdmProductId}
					handleWishlistClick={handleWishlistClick}
					handleBookALikeClick={handleBookALikeClick}
				/>
			);
		// If there are no results after calling constructor, show a custom page
		} else if (!isLoadingResults) {
			return <ZeroResultsPage history={props.history}/>
		}
		// Show nothing while the page is still loading results
		return null;
	}

	const handleAddToCart = (itemProps) => {
		dumbleData.setProductInfo(itemProps, 'product');
		dumbleData.trackAddToCart();
		setaddToCartItem(itemProps);
	}

	const generateTSOLinkMessage = () => {
		let tsoLink;
		if(searchQuery) {
			let queryParams = searchQuery.split(" ").join("%20");
			tsoLink=`${tsoOrigin}/teachers-ecommerce/teacher/search-results.html?search=1&prefilter=&text=${queryParams}&f.product-type=books%2Findividual-titles`;
		} else if (browseFacets.length) {
			let readingLevelParams = browseFacets[0] !== "" ? `&f.${browseFacets[0]}=` + browseFacets[1] : '';
			let gradeParams = browseFacets[2].length ? '&f.grade=' + browseFacets[2].join('&f.grade=') : '';
			let superGenreParams = browseFacets[3].length ? '&f.super-genre=' + browseFacets[3].join('&f.super-genre=') : '';
			let subjectParams = browseFacets[4].length ? '&f.subject=' + browseFacets[4].join('&f.subject=') : '';
			let genreParams = browseFacets[5].length ? '&f.genre=' + browseFacets[5].join('&f.genre=') : '';
			let facetParams = ''.concat(readingLevelParams, gradeParams, superGenreParams, subjectParams, genreParams);
			tsoLink=`${tsoOrigin}/teachers-ecommerce/teacher/shops/book-wizard.html?p=1&n=20${facetParams}`;
		}
		return (
			<a
				target="_blank"
				rel="noopener noreferrer"
				href={tsoLink}>
				{`VIEW ALL IN THE TEACHER STORE`}
			</a>
		)
	}

	const renderViewAllBar = () => {
		let searchResultsCount = numResults;
		let resultsMessage;
		let tsoLinkMessage;

		if(searchResultsCount > 10 && (searchQuery || browseFacets)){
			resultsMessage = "10+ RESULTS"
			tsoLinkMessage = generateTSOLinkMessage();
		} else {
			resultsMessage = `${searchResultsCount} RESULT${searchResultsCount === 1 ? '' : 'S'}`;
		}
		return (
			<ViewAllBar>
				<span>{resultsMessage}</span>{tsoLinkMessage}
			</ViewAllBar>
			)
	}

	const renderViewAllCard = () => {
		let searchResultsCount = numResults;
		let tsoLinkMessage;

		if(!bookALikeItem && searchResultsCount > 10 && (searchQuery || browseFacets)){
			tsoLinkMessage = generateTSOLinkMessage(searchResultsCount, searchQuery);
			return (
				<ViewAllCard>
					{tsoLinkMessage}
				</ViewAllCard>
			)
		}
		return null;
	}


	const renderHeader = () => {
		if (bookALikeItem) {
			return (
				<BookALikeHeader 
					bookALikeItem={bookALikeItem}
					hideOnScroll={hideOnScroll}
					handleHeaderUpdate={handleHeaderUpdate}
					handleAddToCart={handleAddToCart}
					inWishlist={inWishlistHelper(bookALikeItem.data.id)}
					handleWishlistClick={handleWishlistClick}
					decodeText={decodeText}
					headerOffset={headerOffset}
				/>
			)
		} else if(isFilteredResults){
			return(
				<DiscoveryHeaderFilters 
					state={props.location.state.browseQuery}
					numResults={numResults}
					history={props.history}
					viewAllBar={renderViewAllBar()}
					hideOnScroll={hideOnScroll}
					handleHeaderUpdate={handleHeaderUpdate}
					headerOffset={headerOffset}
				/>
			);
		} else if(props.location.search){
			return(
				<LevelHeaderSearch 
					viewAllBar={renderViewAllBar()}
					hideOnScroll={hideOnScroll}
					handleHeaderUpdate={handleHeaderUpdate}
					levelABookSearchQuery={searchQuery}
					headerOffset={headerOffset}
				/>
			);
		}
	}

	/* library to track scroll */
	useScrollPosition(
		({ prevPos, currPos }) => {
			const isShow = currPos.y > -5
			if (isShow !== hideOnScroll) setHideOnScroll(isShow)
		}, [hideOnScroll], false, false, 50 )

	if(props.location.search || (props.location.state && props.location.state.browseQuery)){
		return (
			<React.Fragment>
				<Nav
					addToCartItem={addToCartItem}
					hideOnScroll={hideOnScroll}
					isSignedIn={isSignedIn}
					setIsSignedIn={setIsSignedIn}
					myScholasticModal={myScholasticModal}
					setMyScholasticModal={setMyScholasticModal}
				/>
				
				<SaveToWishlistAlert
					hiddenClass={!wishlistAlert ? "hidden" : ""}
					product={saveToWishlistItem}
					hideOnScroll={hideOnScroll}
					handleAlertClose={() => {
						clearTimeout(alertTimeout.current)
						setWishlistAlert(false)
					}} />
				<div className="resultsPage" style={{'marginTop': `${headerOffset + navOffset}px`}}>
					{renderHeader()}
					<div className="grid-layout">
						{renderBookCards()}
						{renderViewAllCard()}
					</div>
				</div>
				{openMultipleWishlistModal &&(
					<Modal handleModal= {()=>{setOpenMultipleWishlistModal(!openMultipleWishlistModal)}}>
						<iframe id="wishlist-iframe" src= {`${tsoOrigin}/on/demandware.store/Sites-tso-us-Site/default/Wishlist-AddItemToWishlist?pid=${saveToWishlistItem.isbn}-tso-us&spCatalogName=NTS`} title="Multiple Wishlists" class="iframe"/>
					</Modal>
				)}
			</React.Fragment>
		)
	}
	/* if user navigated to /results with no queries, redirect to landing page */
	props.history.push({pathname: '/'});
	return null;
}